module.exports = __webpack_public_path__ + "static/Heebo-Black-c7040aca5a0e902f632f45dd893f5369.ttf";